import { CheckFormState, ProductsMap } from "@/types";

import { getNumberValue } from "./getNumberValue";
import { getUnit } from "./getUnit";

export class CheckFormStorage {
  private readonly localStorageKey: string = "MDRNA_TEMP_EXCURSION_FORM";

  public getStateDefault(): CheckFormState {
    return {
      hours: "",
      minutes: "",
      packaging: null,
      product: null,
      storage: null,
      temperature: "",
      unit: null
    };
  }

  public removeState() {
    try {
      localStorage.removeItem(this.localStorageKey);
    } catch {
      // Ignore failures that occur during Safari private browsing
    }
  }

  public getState(productsMap: ProductsMap | null): CheckFormState {
    if (typeof window !== "undefined") {
      try {
        const storedStateString = localStorage.getItem(this.localStorageKey);

        if (storedStateString === null) {
          return this.getStateDefault();
        }

        const storedState = JSON.parse(storedStateString);
        const hoursNumber = getNumberValue(storedState.hours);
        const hours =
          storedState.hours === "" || (hoursNumber !== null && hoursNumber >= 0)
            ? storedState.hours
            : "";
        const minutesNumber = getNumberValue(storedState.minutes);
        const minutes =
          storedState.minutes === "" || (minutesNumber !== null && minutesNumber >= 0)
            ? storedState.minutes
            : "";
        const unit = getUnit(storedState.unit) || null;
        const products = productsMap ? Object.values(productsMap) : [];
        const productOption = products?.find((p) => p.productId === storedState.product);
        const product = productOption ? productOption.productId : null;
        const packagings = productOption?.packagingMap
          ? Object.values(productOption?.packagingMap)
          : [];
        const packagingOption = packagings.find((p) => p.packagingId === storedState.packaging);
        const packaging = packagingOption ? packagingOption.packagingId : null;
        const storageIds = packagingOption?.storageIds || [];
        const storage = storageIds.find((s) => s === storedState.storage) || null;
        const temperatureNumber = getNumberValue(storedState.temperature);
        const temperature =
          storedState.temperature === "" || temperatureNumber !== null
            ? storedState.temperature
            : "";

        return {
          hours,
          minutes,
          packaging,
          product,
          storage,
          temperature,
          unit
        };
      } catch {
        // Ignore failures that occur during Safari private browsing
      }
    }

    return this.getStateDefault();
  }

  public setState(state: CheckFormState) {
    try {
      localStorage.setItem(this.localStorageKey, JSON.stringify(state));
    } catch {
      // Ignore failures that occur during Safari private browsing
    }
  }
}

export const getCheckFormStorage = () => new CheckFormStorage();
